import { render, staticRenderFns } from "./le-goods-choose.vue?vue&type=template&id=0c18c0bf&scoped=true&"
import script from "./le-goods-choose.vue?vue&type=script&lang=js&"
export * from "./le-goods-choose.vue?vue&type=script&lang=js&"
import style0 from "./le-goods-choose.vue?vue&type=style&index=0&id=0c18c0bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18c0bf",
  null
  
)

export default component.exports